import { useCallback, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Card, Button, message, Tag, Divider } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { FirebaseSessionKey, isMobile } from '../constants'
import { FirebaseApp } from 'firebase/app'
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
  addDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore/lite'
import { StripeElements } from '@stripe/stripe-js'

type Props = {
  firebaseApp: FirebaseApp
  setUserHasBilling: (value?: boolean) => void
}

//const perguntas: any = []

const Payments = ({ firebaseApp, setUserHasBilling }: Props) => {
  const [activePayment, setActivePayment] = useState<any>(undefined)
  const currentUser = JSON.parse(
    window.sessionStorage.getItem(FirebaseSessionKey) as string
  )

  const [paymentLoading, setPaymentLoading] = useState<boolean>(false)

  const stripe = useStripe()
  const elements = useElements()

  const paymentsCall = useCallback(async () => {
    const db = getFirestore(firebaseApp)
    const citiesCol = collection(db, 'billing')
    const q = query(citiesCol, where('user_uid', '==', currentUser.uid))
    const querySnapshot = await getDocs(q)
    const eventList = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }))
    return eventList[0]
  }, [currentUser.uid, firebaseApp])

  const makePaymentsGet = useCallback(() => {
    paymentsCall().then((data: any) => {
      setActivePayment(data || false)
    })
  }, [paymentsCall])

  useEffect(() => {
    if (activePayment === undefined) {
      makePaymentsGet()
    }
  }, [activePayment, makePaymentsGet])

  const handlePaymentSubmit = async () => {
    /*const response = await fetch(
      'https://loja.piroestrela.pt/api/checkout.php',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          paymentMethodType: 'card',
          currency: 'eur',
        }),
      }
    ).then((response) => response.json())

    setIntent(response)*/

    /*if (redirect) {
      window.open(redirect, '_self')
    }*/

    const response = await stripe!.confirmPayment({
      elements: elements as StripeElements,
      confirmParams: {
        return_url: 'https://sercacador.com/dashboard',
      },
      redirect: 'if_required',
    })

    setPaymentLoading(true)

    if (response.error) {
      message.error(response.error.message)
    } else if (response.paymentIntent.status === 'succeeded') {
      const db = getFirestore(firebaseApp)
      const docRef = await addDoc(collection(db, 'billing'), {
        billing_start: new Date(),
        user_uid: currentUser.uid,
        user_email: currentUser.email,
      })

      if (docRef.id) {
        setUserHasBilling(undefined)
        makePaymentsGet()
        message.success('Pagamento efectuado com sucesso!')
      } else {
        message.error(
          'Ocorreu um problema, não conseguimos validar o pagamento.'
        )
      }
    } else {
      message.error('Ocorreu um problema, não conseguimos validar o pagamento.')
    }

    setPaymentLoading(false)
  }

  const CardContent = () => {
    const toPay = () => (
      <>
        <p>
          Subscrição:{' '}
          <Tag icon={<CheckCircleOutlined />} color="error">
            Inactiva
          </Tag>
        </p>
        <p>
          Para ter acesso a todos os conteúdos deve fazer o pagamento na secção
          abaixo.
        </p>
        <p>O seu sucesso esta à distância de um click.</p>
        <Divider>Dados para Pagamento</Divider>
        <h3>Total: €27.00</h3>
        {<PaymentElement />}
        <Button
          type="primary"
          onClick={() => {
            handlePaymentSubmit()
          }}
          style={{ marginTop: '20px' }}
        >
          Comprar
        </Button>
        <Divider>Transferência Bancária</Divider>
        <h4>
          IBAN: <Tag color="success">LT02 3250 0602 7723 4275</Tag>Deve indicar
          o seu email nas notas da transferência
        </h4>
        <Divider>MBWAY</Divider>
        <h4>
          Enviar para: <Tag color="success">910 834 344</Tag>Deve indicar o seu
          email nas notas da transferência
        </h4>
      </>
    )

    if (activePayment === false) {
      return toPay()
    } else {
      const billingDate = moment(activePayment.billing_start.toDate())
      const expiryDate = billingDate.clone().add(6, 'months')

      const isSubscriptionExpired = !(moment().diff(expiryDate) < 0)

      if (isSubscriptionExpired) {
        const db = getFirestore(firebaseApp)
        deleteDoc(doc(db, 'billing', activePayment.id))
        makePaymentsGet()
        return toPay()
      }

      return (
        <>
          <p>
            Subscrição:{' '}
            <Tag icon={<CheckCircleOutlined />} color="success">
              Activa
            </Tag>
          </p>
          <p>
            Valida até:{' '}
            <Tag color="success">
              {expiryDate.format('DD/MM/YYYY - HH:MM:SS')}
            </Tag>
          </p>
        </>
      )
    }
  }

  /*const timer = (ms: number) => new Promise((res) => setTimeout(res, ms))

  const adicionar = async () => {
    const db = getFirestore(firebaseApp)

    for (var i = 0; i < perguntas.length; i++) {
      const pergunta = perguntas[i]
      const docRef = await addDoc(collection(db, 'questionslupa'), pergunta)

      if (docRef.id) {
        console.log('adicionou: ', pergunta._id)
      } else {
        console.log('falhou: ', pergunta._id)
      }
      await timer(1500) // then the created Promise can be awaited
    }
  }*/

  return (
    <Container>
      <Card
        type="inner"
        loading={activePayment === undefined || paymentLoading}
        title={
          <p style={{ fontWeight: 'bold', margin: '0', fontSize: '16px' }}>
            Estado da Subscrição do serviço:
          </p>
        }
        style={{
          marginBottom: '15px',
          fontWeight: 'bold',
          width: isMobile ? '100%' : '800px',
          overflowY: 'auto',
        }}
      >
        {activePayment !== undefined && <CardContent />}
      </Card>
      {/*
        <Button
          type="primary"
          onClick={() => {
            adicionar()
          }}
          style={{ marginTop: '20px' }}
        >
          Adicionar perguntas
        </Button>
        */}
    </Container>
  )
}

export default Payments

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 100%;
  padding: 50px;

  @media (max-width: 768px) {
    padding: 5px;
  }
`
